import _ from 'lodash'

// Given information about an API request from axios,
// store the value of the X-API-VERSION header for the
// the first response in this session, then if the API
// version changes during this session, force a refresh
// to get updated JS code.
export const verifyAPIVersion = (data, headers) => {
  const apiVersion = headers['x-api-version']
  const sessionVersion = window.sessionStorage.apiVersion

  if (_.isNil(apiVersion)) {
    // do nothing
  } else if (_.isNil(sessionVersion)) {
    window.sessionStorage.apiVersion = apiVersion
  } else if (sessionVersion !== apiVersion) {
    window.sessionStorage.apiVersion = apiVersion
    window.location.reload()
  }

  return data
}
